import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useOperatorParam() {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const raw = searchParams.get('operator') || '';
    return raw
      .split(',')
      .filter(Boolean)
      .map(decodeURIComponent)
      .sort()
      .join(',');
  }, [searchParams]);
}
